import { Component, inject } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-accessibility-disclaimer',
    templateUrl: './accessibility-disclaimer.page.html',
    styleUrls: ['./accessibility-disclaimer.page.scss'],
    imports: [IonicModule, TranslatePipe]
})
export class AccessibilityDisclaimerPage {
  translate = inject(TranslateService);
  modalController = inject(ModalController);
}
